import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useIntl } from 'react-intl'
import { deleteMultiCartComment } from 'api/cart/deleteMultiCartComment'
import { showSnackbar } from 'LuxKit/Snackbar/AppSnackbar'
import { COMMENT_QUERY_KEY } from 'constants/comments'

interface DeleteCommentParams {
  multiCartId: string
  commentId: string
}

export function useDeleteMultiCartComment() {
  const queryClient = useQueryClient()
  const intl = useIntl()

  return useMutation({
    mutationFn: (params: DeleteCommentParams) => deleteMultiCartComment(
      params.multiCartId,
      params.commentId,
    ),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: [COMMENT_QUERY_KEY, variables.multiCartId] })
    },
    onError: (error: Error) => {
      showSnackbar(intl.formatMessage({
        id: '9ht_h3mv4xVHheCAyVwq',
        defaultMessage: 'Failed to delete comment: {errorMessage}',
        description: 'Snackbar error message when deleting a shared cart comment fails',
      }, { errorMessage: error.message }), 'critical')
    },
  })
}
